import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import PlaceOrder from '../components/PlaceOrder'
import { actionCreators } from '../actions'

const mapStateToProps = (state) => ({
  order: state.order, // gives our component access to state through props
  paymentApp: state.transaction.paymentApp,
  redirectUrl: state.transaction.redirectUrl,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrder)
